import chroma from "chroma-js";

/* From a primary color, create a `primaryDark` and `primaryFaded` */
export const createPrimaryColors = (primary: string) => ({
  primary,
  primaryDark: chroma(primary).darken(0.25).hex(),
  primaryFaded: chroma(primary).alpha(0.45).hex(),
  primaryLight: chroma(primary).alpha(0.2).hex(),
  primaryLightest: chroma(primary).alpha(0.1).hex(),
});
